
<style scoped>

  .homeBody{
    width: 100%;
  }
  .bannerMain{
    width: 100%;
    background-color: #e8e8e8;
  }
  .bannerBox{
    width: 100%;
    position: relative;
  }
  .bannerBox .bannerImg{
    width:100%;

  }
  .bannerBox .text{
    width: 100%;
    position: absolute;
    text-align: center;

  }

  .bannerBox .text1{
    text-align: left;
    left: 15%;
    width: 100%;
    top: 15%;
  }
  .bannerBox .text1-1{
    font-size: 20px;
    color: #FFFFFF;
    letter-spacing: 3px;
  }
  .bannerBox .text1-2-1{
    font-size: 70px;
    color: #FFFFFF;
    margin-top: 30px;
    margin-bottom: 10px;
    letter-spacing: 5px;
  }
  .bannerBox .text1-2-2{
    font-size: 70px;
    color: #FFFFFF;
    margin-bottom: 30px;
    letter-spacing: 5px;
  }
  .bannerBox .text1-3{
    font-size: 20px;
    color: #0a214e;
    background-color: rgba(255, 255, 255, 0.6);
    display: inline-block;
    width: 150px;
    height: 50px;
    line-height: 50px;
    border-radius: 30px;
    text-align: center;
    cursor: pointer;
  }
  .bannerBox .text1-3:hover{
    background-color: #FFFFFF;
  }
  .bannerBox .text1-6{
    position: absolute;
    right: 30%;
  }
  .bannerBox .text1-4{
    font-size: 20px;
    color: #FFFFFF;
    letter-spacing: 3px;
    display: inline-block;
    width: 100px;
    height: 100px;
    border: #9A9A9AFF 1px solid;
    padding: 20px 10px 0px 20px;

  }
  .bannerBox .text1-5{
    font-size: 20px;
    color: #FFFFFF;
    letter-spacing: 3px;
    display: inline-block;
    width: 100px;
    height: 100px;
    border: #9a9a9a 1px solid;
    padding: 20px 10px 0px 20px;
    margin-left: 50px;
  }
  .bannerBox .text1-4-1{
    font-size: 16px;
  }
  .bannerBox .text1-4-3{
    font-size: 10px;
    color: #909399;
    margin-top: 20px;
  }

  .bannerBox .text2{
    width: 100%;
    top: 30%;
  }
  .bannerBox .text2-1{
    font-size: 20px;
    color: #FFFFFF;
    letter-spacing: 3px;
  }
  .bannerBox .text2-2{
    font-size: 70px;
    color: #FFFFFF;
    margin-top: 40px;
    margin-bottom: 60px;
    letter-spacing: 5px;
  }

  .bannerBox .text3{
    width: 100%;
    top: 30%;
  }

  .bannerBox .text3-1{
    font-size: 20px;
    color: #FFFFFF;
    letter-spacing: 3px;
  }
  .bannerBox .text3-2{
    font-size: 70px;
    color: #FFFFFF;
    margin-top: 40px;
    margin-bottom: 60px;
    letter-spacing: 5px;
  }
  .bannerBox .text3-4{
    font-size: 20px;
    color: #FFFFFF;
    letter-spacing: 3px;
    margin-bottom: 40px;
  }
  .bannerBox .text3-5{
    font-size: 14px;
    color: #FFFFFF;
    position: absolute;
    right: 10%;
    margin-top: 20px;
    border: #909399 1px solid;
    padding: 10px;
  }
  .bannerBox .text3-5 span{
    padding: 0 10px 0 10px;
  }

  .bannerBox .textButton{
    font-size: 20px;
    color: rgba(255, 255, 255, 0.70);
    display: inline-block;
    text-align: center;
    line-height: 60px;
    width: 200px;
    height: 60px;
    cursor: pointer;
    background-image: none;
    top: 80%;
    clear: both;
  }
  .bannerBox .textButton:hover{
    color:#FFFFFF;
  }
</style>
<template>
  <div class="home">
    <Header ref="child" selected="0"/>
    <RightMenu></RightMenu>
    <div class="homeBody">
      <div class="bannerMain">
        <swiper ref="bannerSwiper" :options="swiperBannerOptions" style="margin:0 auto;top: -84px;">
          <swiper-slide :key="1" >
            <div class="bannerBox" href="javascript:void(0);" @mouseenter="stopBannerAuto()" @mouseleave="toBannerAuto()">
              <img :src="imgArray[0]" class="bannerImg"/>
              <div class="text text1" >
                <p class="text1-1">精培，你的一站式留学管家</p>
                <p class="text1-2-1">改变从这里开始</p>
                <p class="text1-2-2">逆袭学霸就趁现在</p>
                <a class="text1-3" href="/course">课程介绍</a>
                <div class="text1-6">
                  <div class="text1-4"><p class="text1-4-1">始于</p><p class="text1-4-2">2016</p><p class="text1-4-3">when</p></div>
                  <div class="text1-5"><p class="text1-4-1">450+</p><p>精英导师</p><p class="text1-4-3">who</p></div>
                </div>
              </div>
              <a class="textButton swiper-button-prev"><i class="el-icon-d-arrow-left"></i>申研升学</a>
              <a class="textButton swiper-button-next">职业咨询<i class="el-icon-d-arrow-right"></i></a>
            </div>
          </swiper-slide>
          <swiper-slide :key="2" >
            <div class="bannerBox" href="javascript:void(0);" @mouseenter="stopBannerAuto()" @mouseleave="toBannerAuto()">
              <img :src="imgArray[1]" class="bannerImg"/>
              <div class="text text2" >
                <p class="text2-1">精培面试官为你靶向匹配你的最佳工作岗位</p>
                <p class="text2-2">一站式留学生职业服务</p>
                <a class="text1-3">进入官网</a>
              </div>
              <a class="textButton swiper-button-prev"><i class="el-icon-d-arrow-left"></i>课程辅导</a>
              <a class="textButton swiper-button-next">申研升学<i class="el-icon-d-arrow-right"></i></a>
            </div>
          </swiper-slide>
          <swiper-slide :key="3" >
            <div class="bannerBox" href="javascript:void(0);" @mouseenter="stopBannerAuto()" @mouseleave="toBannerAuto()">
              <img :src="imgArray[2]" class="bannerImg"/>
              <div class="text text3" >
                <p class="text3-1">升学｜转学｜签证｜移民｜雇主担保｜移民凑分｜工作经验</p>
                <p class="text3-2">GA-MAIN留学移民直通车</p>
                <p class="text3-4">申请流程1V1指导｜申请方向及重点评估｜申请材料协助准备</p>
                <a class="text1-3">进入官网</a>
                <p class="text3-5"><span>申请流程1V1指导</span>｜<span>申请方向及重点评估</span>｜<span>申请材料协助准备</span></p>
              </div>
              <a class="textButton swiper-button-prev"><i class="el-icon-d-arrow-left"></i>职业咨询</a>
              <a class="textButton swiper-button-next">课程辅导<i class="el-icon-d-arrow-right"></i></a>
            </div>
          </swiper-slide>
<!--          <div class="swiper-button-prev" slot="button-prev"></div>-->
<!--          <div class="swiper-button-next" slot="button-next"></div>-->
<!--          <div class="swiper-pagination" slot="pagination"></div>-->
        </swiper>
      </div>
      <div class="jingpeiIntro">
        <div class="aboutJingpei">
          <h2>
            精培国际教育
          </h2>
          <div class="linedown"><div class="lineCloth"><div class="linedownBody"></div></div></div>
          <div class="introDetail">
            <span>精培国际教育（GAMAIN GROUP）于2016年在澳大利亚悉尼成立 ，自成立以来已在澳大利亚，加拿大，英国等地设有教育培训基地。任课导师均为毕业成绩85+，含学年第一及校内华人教授共同备课。导师团队超过450人，累积服务学员11万人。 在澳大利亚悉尼、墨尔本、阿德莱德，加拿大多伦多、哈利法克斯，英国曼彻斯特，伦敦、滑铁卢等地设有教育培训基地。 补习端课程覆盖商科（金融、会计、数学、统计）；工科；IT，统计，医学，法律，Media，CFA,CPA等近百⻔课程。在名师指导下使同学们更易克服语⾔、学术、⽂化等困难。课上导师用丰富的答题经验使同学更快更好地融⼊⼤学⽣活并取得高分，成功上岸。</span>
            <span>GAMAIN GROUP致力于继续完善海外学习及职业发展全生态周期服务系统，为更多求学者提供国际化教育资源，在帮助留学生在海外学习及职业发展取得成功的同时，也为国际教育资源共享、国际文化交流作出贡献。作为澳洲首家教育联盟及留学后续服务的开辟者，公司在中国海南自贸港成立总部。旨在打造以服务留学生为中心，促进中西方教育交流的国际教育品</span>
          </div>
          <div class="introDataBox">
            <div class="introData">
              <p class="p1">130000+</p>
              <p class="p2">线上学员</p>
            </div>
            <div class="introData">
              <p class="p1">450+</p>
              <p class="p2">精英导师</p>
            </div>
            <div class="introData">
              <p class="p1">270000+</p>
              <p class="p2">平台线上人数</p>
            </div>
            <div class="introData">
              <p class="p1">100000+</p>
              <p class="p2">服务线下学员</p>
            </div>
            <div class="introDataLast">
              <p class="p1">900+</p>
              <p class="p2">开设课程</p>
            </div>
          </div>
        </div>
      </div>

      <div class="classIntro">
        <ul class="classIntroUl">
          <li>
            <img src="../assets/img/college/college1.jpeg" class="backImg" />
            <a href="javascript:void(0);">
              <h4>澳大利亚</h4>
              <h4>悉尼大学</h4>
              <div>University of Sydney</div>
            </a>
          </li>
          <li>
            <img src="../assets/img/college/college2.jpeg" class="backImg" />
            <a href="javascript:void(0);">
              <h4>澳大利亚</h4>
              <h4>麦考瑞大学</h4>
              <div>University of Macquarie</div>
            </a>
          </li>
          <li>
            <img src="../assets/img/college/college3.jpeg" class="backImg" />
            <a href="javascript:void(0);">
              <h4>澳大利亚</h4>
              <h4>新南威尔士大学</h4>
              <div>University of New South Wales</div>
            </a>
          </li>
          <li>
            <img src="../assets/img/college/college4.jpeg" class="backImg" />
            <a href="javascript:void(0);">
              <h4>澳大利亚</h4>
              <h4>莫纳什大学</h4>
              <div>University of Monash</div>
            </a>
          </li>
          <li>
            <img src="../assets/img/college/college5.jpeg" class="backImg" />
            <a href="javascript:void(0);">
              <h4>加拿大</h4>
              <h4>达尔豪斯大学</h4>
              <div>University of Dalhousie</div>
            </a>
          </li>
          <li>
            <img src="../assets/img/college/college6.jpeg" class="backImg" />
            <a href="javascript:void(0);">
              <h4>加拿大</h4>
              <h4>曼尼托巴大学</h4>
              <div>University of Manitoba</div>
            </a>
          </li>
          <li>
            <img src="../assets/img/college/college7.jpeg" class="backImg" />
            <a href="javascript:void(0);">
              <h4>英国</h4>
              <h4>曼彻斯特大学</h4>
              <div>University of Manchester</div>
            </a>
          </li>
          <li>
            <img src="../assets/img/college/college8.jpeg" class="backImg" />
            <a href="javascript:void(0);">
              <h4>英国</h4>
              <h4>国王大学</h4>
              <div>University of KCL</div>
            </a>
          </li>
        </ul>
      </div>


    </div>

    <div class="ourProduct">
      <div class="teacherHead"><h2 class="teacherHead1">我们的课程产品</h2></div>
      <div class="linedown"><div class="lineCloth"><div class="linedownBody"></div></div></div>
      <div class="productIntro"><span>补习端课程覆盖商科（金融、会计、数学、统计）；工科；IT，统计，医学，法律，Media等近百门课程。在名师指导下使同学们更易克服语⾔、学术、⽂化等困难。课上导师用丰富的答题经验使同学更快更好地融⼊⼤学⽣活并取得高分，成功上岸。</span></div>
      <div class="product">
        <div class="ppp">
          <div class="productChild">
            <div class="productChild1">周课</div>

            <div class="productChild2">
              <img src="../assets/img/classIco.png" class="productChild3">
              <div class="productChild4">⼩班周课为学⽣提供每周课程，对⼤学课程内容进⾏每周回顾与讲解，总结⼀周知识点，紧跟学习课程节奏，帮助同学们以最快的时间答疑解惑，缓解课业压⼒。</div>
            </div>
          </div>
          <div class="productChild">
            <div class="productChild1">REVIEW</div>

            <div class="productChild2">
              <img src="../assets/img/review.png" class="productChild3">
              <div class="productChild4">每次考前的考前强化课程，不限时的答疑辅导环节(Review Session)将按季度年度梳理半年、全年课程知识点与考点，并提供海量习题训练与讲解，更有不限时的答疑辅导环节。</div>
            </div>
          </div>
          <div class="productChild">
            <div class="productChild1">1V1</div>

            <div class="productChild2">
              <img src="../assets/img/1v1.png" class="productChild3">
              <div class="productChild4">对每位周课学员开设时⻓远超在校教授和讲师的答疑辅导，最⼤程度剖析难点疑点。⼀对⼀辅导针对不同程度的学⽣，重点练习，效率翻倍。</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="teacherIntro">
      <div class="teacherHead"><h2 class="teacherHead1">优秀学员褒奖</h2></div>
<!--      <div class="teacherHead"><h4 class="teacherHead2">澳洲专业的教师团队 , 打造精英化教育行业</h4></div>-->
      <div class="linedown"><div class="lineCloth"><div class="linedownBody"></div></div></div>
      <div style="margin: 20px auto 50px auto;">
        <div class="teacherPic">
          <swiper ref="studentSwiper" :options="swiperStudentsOptions" style="margin:0 auto;max-width: 1200px;" v-if="imgStudent.length">
            <swiper-slide v-for="(intem,index) in imgStudent" :key="index">
              <div class="teacherBody student" @mouseenter="stopAuto()" @mouseleave="toAuto()">
                <div class="studentPraise">
                  <div class="praiseDetail">
                    <div style="">
                      <img src="../assets/img/student.png"/>
                      <p>精培教育（{{intem.school}}）</p>
                      <p>{{intem.grade}} 届优秀学员代表 {{intem.name}}</p>
                      <p>{{intem.honor}}</p>
                    </div>
                  </div>
                  <div class="praiseContent">{{intem.detail}}</div>
                </div>
              </div>
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>
      <div>
      <div class="teacherPic">
        <swiper ref="mySwiper" :options="swiperOptions" style="margin:0 auto;max-width: 900px;" v-if="imgTeacher.length">
          <swiper-slide v-for="(intem,index) in imgTeacher" :key="index">
<!--            <a href="#"></a>-->
            <div class="teacherBody feedback" @mouseenter="stopAuto()" @mouseleave="toAuto()">
              <img :src="intem" class="teacherImg" />
<!--              <div class="teacherDetail">
                <h2>Ben</h2>
                <span class="line"></span>
                <div class="teacherText">
                  Ben是CFA全球TOP10%，10A成就者, 拥有丰富的CFA一级教学经验。</br>
                  Ben以年级第一毕业于应用金融专业，绩点4.0/4.0。曾拿下数学金融，投资学，高级公司金融，财务管理，商业统计等多项年级第一，获得精算与商业分析学院授予的AMP奖学金，商学院Merit list Top 1%荣誉学员。FRM考试全1 level。在金融、统计均有强悍的成绩背景，被称为“金融学神”。</br>
                  Ben 大学期间就开始不断教授学校课程。课堂幽默活跃，教学思维独特高效，深受学生喜爱。其在CFA一级课程的教学在悉尼独领风骚，对于出题套路的见解让学生能在最短时间内掌握考点。</br>
                </div>
              </div>-->
            </div>
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
      </div>
    </div>
    <div class="collegeIntro">
      <div class="collegeHead"><h2>旗下品牌</h2></div>
      <div class="linedown"><div class="lineCloth"><div class="linedownBody"></div></div></div>
      <div class="collegeBody">
        <ul class="collegeUl">
          <li v-for="item in imgBrand" :key="item.name">
            <img :src="item">
          </li>
        </ul>
      </div>
      <div class="collegeHead"><h2>合作伙伴</h2></div>
      <div class="linedown"><div class="lineCloth"><div class="linedownBody"></div></div></div>
      <div class="collegeBody">
        <ul class="collegeUl">
          <li v-for="item in imgPartner" :key="item.name">
            <img :src="item">
          </li>
        </ul>
      </div>
    </div>
    <Footer ref="child" />
  </div>
</template>
<style scoped>
.teacherIntro .teacherBody .studentPraise{
  width: 80%;
  height: auto;
  margin: 0 auto 0 auto;
  border: 2px solid #bfbfbf;
  padding: 40px 30px 40px 30px;
  border-radius: 5px;
}
.praiseDetail{
  text-align: center;
}
.praiseDetail div{
  max-width: 500px;
  margin: 0 auto 0 auto;
}
.praiseDetail p{
  line-height: 28px;
  font-size: 20px;
  text-align: left;
  color: gray;
  letter-spacing: 2px
}
.praiseDetail img{
  max-width: 80px;
  float: left;
  margin-right: 20px;
}
.praiseContent{
  text-align: left;
  margin: 20px 10px 20px 10px;
  font-size: 16px;
  color: #999;
  letter-spacing: 1px
}


.collegeIntro{
  width: 100%;
  text-align: center;
  padding: 20px 0 20px 0;
  background-color: #e8e8e8;
}
.collegeIntro .collegeHead{
  margin: 5px 0 5px 0;
}
.collegeIntro .collegeHead h2{
  display: inline-block;
  padding: 0 auto 0 auto;
  font-size: 2.5em;
  color: #c4a464;
}
.collegeUl{
  width: 1200px;
  display: inline-block;
  padding: 0 auto 0 auto;
}
.collegeUl li{
  float: left;
  margin: 5px;
  width: 150px;
  text-align: left;
  border-radius: 5px !important;
  overflow: hidden;
  height: 150px;
}
.collegeUl li img{
  width: 100%;
}

.teacherIntro{
  width: 100%;
  text-align: center;
  padding: 20px 0 20px 0;
}
.teacherHead{
  margin: 5px 0 5px 0;
}
.teacherHead1{
  display: inline-block;
  padding: 0 auto 0 auto;
  font-size: 2.5em;
  color: #c4a464;
}
.teacherHead2{
  display: inline-block;
  padding: 0 auto 0 auto;
  color: #c4a464;
}
.teacherIntro .teacherPic{
  width: 100%;
  display: inline-block;
  padding: 0 auto 0 auto;
}
.teacherIntro .teacherBody{
  cursor:pointer;
  cursor:hand;
  text-align: center;
}
.teacherIntro .student{
  height: 100%;
}
.teacherIntro .feedback{
  height: 450px;
}
.teacherIntro .teacherBody .teacherImg{
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
  left: 0;
}

.teacherIntro .teacherBody .teacherDetail{
  width: 100%;
  max-height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  overflow: hidden;
  top:90%;
}
.teacherIntro .teacherBody .teacherDetail h2{
  padding: 5px 0 0 10px;
  color: #c4a464;
}
.teacherIntro .teacherBody .teacherDetail .line{
  width: 100px;
  height: 5px;
  display: inline-block;
  border-radius: 25px;
  margin: 0 0 5px 10px;
  position: absolute;
  background-color: #c4a464;
}
.teacherIntro .teacherBody .teacherDetail .teacherText{
  padding: 10px;
  line-height: 25px;
  color: #c4a464;
}
.teacherIntro .teacherBody:hover .teacherDetail{
  top: auto;
  bottom: 0;
}

.ourProduct{
  width: 100%;
  text-align: center;
  padding: 20px 0 20px 0;
  background-color: #e8e8e8;
}
.ourProduct .productIntro{
  max-width: 100%;
}
.ourProduct .productIntro span{
  max-width: 1000px;
  display: inline-block;
  padding: 20px;
  color: #909399;
  font-size: 20px;
  line-height: 2em;
  text-align: left;
}
.ourProduct .product{
  max-width: 1000px;
  padding: 0 auto 0 auto;
  display: inline-block;
  clear: both;
}
.ourProduct .ppp{
  max-width: 1000px;
}
.ourProduct .product .productChild{
  width: 288px;
  height: 380px;
  margin: 10px;
  float: left;
}
.ourProduct .productChild .productChild1{
  width: 100%;
  height: 50px;
  font-size: 30px;
  color: #FFFFFF;
  line-height: 50px;
  background-color: #d0a64c;
}
.ourProduct .productChild .productChild2{
  width: 226px;
  height: 290px;
  padding: 20px 30px 20px 30px;
  border-left: 1px solid #909399;
  border-right: 1px solid #909399;
  border-bottom: 1px solid #909399;
}
.ourProduct .productChild .productChild3{
  width: 80px;
  margin-bottom: 20px;
}
.ourProduct .productChild .productChild4{
  color: #909399;
  font-size: 17px;
  text-align: left;
  line-height: 1.75em;
}
</style>
<script>
import Header from './HeaderMain';
import Footer from "./Footer";
import Banner from "./banner";
import RightMenu from "./RightMenu";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default { //导出变量，函数模块等给其他地方使用
  name: 'Home', //表示给组件起名
  components : {
    Banner,
    Footer,
    Header,
    RightMenu,
    swiper,
    swiperSlide
  },
  data() {
    return {
      msg : 'Welcome to Your jingpei',
      selected: 2,
      imgBrand:[
        require('@static/img/brand/1.png'),
        require('@static/img/brand/2.png'),
        require('@static/img/brand/3.png'),
        require('@static/img/brand/4.png'),
        require('@static/img/brand/5.png'),
        require('@static/img/brand/6.png'),
        require('@static/img/brand/7.png'),
        require('@static/img/brand/8.png'),
        require('@static/img/brand/9.png'),
      ],
      imgPartner:[
        require('@static/img/partner/1.png'),
        require('@static/img/partner/2.png'),
        require('@static/img/partner/3.png'),
        require('@static/img/partner/4.png'),
        require('@static/img/partner/5.png'),
        require('@static/img/partner/6.png'),
        require('@static/img/partner/7.png'),
        require('@static/img/partner/8.png'),
        require('@static/img/partner/9.png'),
        require('@static/img/partner/10.png'),
      ],
      imgArray:[
        require('@static/img/1.jpeg'),
        require('@static/img/2.jpeg'),
        require('@static/img/3.jpeg'),
        require('@static/img/4.jpeg')
      ],
      imgTeacher:[],
      imgStudent:[],
      swiperBannerOptions: {
        //自动播放设置
        autoplay: {
          delay: 2000000,
          stopOnLastSlide: false,
          /* 触摸滑动后是否继续轮播 */
          disableOnInteraction: false,
          pauseOnMouseEnter:true
        },
        speed: 2000,
        //图片下面有小圆点，代表到哪一张图片
        pagination: {
          el: '.swiper-pagination'
        },
        //分页的切换设置
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,//修改swiper的父元素时，自动初始化swiper
        loop: true
      },
      swiperOptions: {
        //自动播放设置
        autoplay: {
          delay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
          pauseOnMouseEnter:true
        },
        speed: 2000,
        //图片下面有小圆点，代表到哪一张图片
        pagination: {
          el: '.swiper-pagination'
        },
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        loop:true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        //下面这三个是图片的轮播展示效果
        effect: 'coverflow',
        slidesPerView: 3,
        coverflowEffect: {
          rotate: 10,
          stretch: -10,
          depth: 50,
          modifier: 2,
          slideShadows : true
        },
      },
      swiperStudentsOptions: {
        //自动播放设置
        autoplay: {
          delay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
          pauseOnMouseEnter:true
        },
        speed: 2000,
        //图片下面有小圆点，代表到哪一张图片
        pagination: {
          el: '.swiper-pagination'
        },
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        loop:true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        //下面这三个是图片的轮播展示效果
        effect: 'slide',
        slidesPerView: 1,
      }
    }
  },
  created() {
    if(this.$utils.isMobile()){
      this.swiperOptions.slidesPerView = 1;
    }

    this.getData();
  },
  mounted() {
  },
  destroyed () {
  },
  methods : {
    stopAuto(){
      this.$refs.mySwiper.swiper.autoplay.stop();
    },
    toAuto(){
      this.$refs.mySwiper.swiper.autoplay.start();
    },
    stopBannerAuto(){
      this.$refs.bannerSwiper.swiper.autoplay.stop();
    },
    toBannerAuto(){
      this.$refs.bannerSwiper.swiper.autoplay.start();
    },

    getData(){
      const that = this;
      this.$axios.get(that.SERVER_API_URL + '/jinpei/getPraise').then(response => {
        if(response.status == 200) {
          return response.data;
        }
      })
        .then(json => {
          if(this.$utils.isEmpty(json)){
            console.log("空数据");
          }else{
            console.log(json);
            this.imgStudent = json;
          }
        });
      this.$axios.get(that.SERVER_API_URL + '/jinpei/getFeedback').then(response => {
        if(response.status == 200) {
          return response.data;
        }
      })
        .then(json => {
          if(this.$utils.isEmpty(json)){
            console.log("空数据");
          }else{
            console.log(json);
            this.imgTeacher = json;
          }
        });
    }
  }
}
</script>

<style scoped>
img{vertical-align:top;}
.swiper-container {
  --swiper-theme-color: #ff6600; /* 设置Swiper风格 */
  --swiper-navigation-color: #00ff33; /* 单独设置按钮颜色 */
  --swiper-navigation-size: 50px; /* 设置按钮大小 */
}

#app{
  height: auto;
  overflow: scroll;
}
  .backImg{
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: -1;
    opacity: 0.5;
  }
  a{
    color: #c4a464;
  }
  .classIntro{
    width: 100%;
    text-align: center;
  }
  .classIntroUl{
    display: inline-block;
    padding: 0 auto 0 auto;
    max-width: 1200px;
  }
  .classIntroUl li{
    position: relative;
    float: left;
    width: 300px;
    text-align: center;
  }
  .classIntroUl li:hover{
    box-shadow: 0px 10px 25px 0 #4C4C4CEE !important;
    z-index: 9;
  }

  .classIntroUl li a{
    display: inline-block;
    width: 300px;
    height: 150px;
    padding: 50px 0px 40px 0px;
    text-align: center;
    overflow: hidden;
    line-height: 50px;
  }
  .classIntroUl li h4{
    font-size: 30px;
    color: #0a214e;
  }
  .classIntroUl li a div{
    font-size: 14px;
    color: #304974;
  }
  /*精培简介*/
  .linedown{
    padding: 5px 0 15px 0;
    width: 100%;
    text-align: center;
    line-height: 0;
  }
  .linedown .lineCloth{
    padding: 0 auto 0 auto;
    display: inline-block;
    width: 130px;
    height: 3px;
    border-bottom: 1px solid #c4a464;
  }
  .linedown .lineCloth .linedownBody{
    padding: 0 auto 0 auto;
    display: inline-block;
    width: 50px;
    height: 3px;
    background-color: #c4a464;
  }
  .jingpeiIntro{
    clear: both;
    width: 100%;
    text-align: center;
    background-color: #e8e8e8;
/*    -webkit-background-size: 100%;
    -o-background-size: auto 100%;*/
    /*background-color: #32333b;*/
  }
  .jingpeiIntro .aboutJingpei{
    display: inline-block;
    padding: 0 auto 0 auto !important;
    padding-bottom: 30px;
    max-width: 1200px;
  }
  .jingpeiIntro .introDetail{
    max-width: 800px;
    color: #6f6135;
    display: inline-block;
    padding: 0 auto 0 auto;
  }
  .jingpeiIntro .aboutJingpei h2{
    font-size: 2.5em;
    padding: 20px 0 0 0;
    color: #c4a464;
  }

  .jingpeiIntro .introDetail span{
    text-align: left;
    text-indent: 2em;
    display: block;
    line-height: 25px;
    max-width: 1000px;
    padding: 10px 20px 10px 20px;
  }

  .jingpeiIntro .introDataBox{
    display: inline-block;
    padding: 0 auto 0 auto;
    width: 100%;
    text-align: center;
  }
  .jingpeiIntro .introData{
    float: left;
    border-right: #eeac32 1px solid;
    margin: 20px 0 20px 0;
    padding: 5px 0px 5px 0px;
    width: 20%;
    min-width: 120px;
  }
  .jingpeiIntro .introDataLast{
    float: left;
    margin: 20px 0 20px 0;
    padding: 5px 0px 5px 0px;
    width: 19%;
    min-width: 120px;
  }
  .jingpeiIntro .introData .p1,.introDataLast .p1{
    font-size: 25px;
    color: #eeac32;
  }
  .jingpeiIntro .introData .p2,.introDataLast .p2{
    font-size: 12px;
    margin-top: 5px;
    color: #32333b;
  }

@media screen and (max-width:1200px){
    .classIntroUl{
      display: inline-block;
      padding: 0 auto 0 auto;
      max-width: 900px;
    }
    .jingpeiIntro .aboutJingpei{
      max-width: 900px;
    }
  .teacherIntro .teacherPic{
    width: 900px;
    display: inline-block;
    padding: 0 auto 0 auto;
  }
  .collegeUl{
    width: 900px;
  }
  }
  @media screen and (max-width:900px){
    .classIntroUl{
      display: inline-block;
      padding: 0 auto 0 auto;
      max-width: 600px;
    }
    .teacherIntro .teacherPic{
      width: 100%;
      display: inline-block;
      padding: 0 auto 0 auto;
    }
    .collegeUl{
      width: 600px;
    }
    .ourProduct .ppp{
      max-width: 620px;
    }
  }
  @media screen and (max-width:700px){
    .bannerMain{
      display: none;
    }
    .classIntroUl{
      display: inline-block;
      padding: 0 auto 0 auto;
      max-width: 100%;
    }
    .teacherIntro .student{
      /*height: 100px;*/
    }
    .teacherIntro .feedback{
      height: 800px;
    }
    .classIntroUl li{
      display: block;
      float: none;
      max-width: 600px;
      width: 100%;
      height: 280px;
    }
    .classIntroUl li a{
      display: inline-block;
      max-width: 400px;
      height: 200px;
      padding: 40px 40px 40px 40px;
      text-align: left;
      overflow: hidden;
    }
    .introDetail{
      max-width: 100%;
    }
    .jingpeiIntro .introPic{
      max-width: 100%;
    }
    .jingpeiIntro .introPic img{
      max-width: 80%;
    }
    .jingpeiIntro .introDetail span{
      max-width: 100%;
    }
    .collegeUl{
      width: 320px;
    }
    .product .ppp{
      width: 310px;
    }
    .praiseDetail p{
      line-height: 20px;
      font-size: 16px;
      letter-spacing: normal;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue